import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const tabSections = document.querySelectorAll('.tabs-logos');

  tabSections.forEach((section) => {
    const buttons = section.querySelectorAll('.tabs-logos__title');
    const contents = section.querySelectorAll('.tabs-logos__logos');
    const contentWrapper = section.querySelector('.tabs-logos__content');

    if (!contentWrapper) return;

    const updateHeight = (activeIndex) => {
      const activeContent = contents[activeIndex];
      if (activeContent) {
        contentWrapper.style.height = `${activeContent.scrollHeight}px`;
      }
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        buttons.forEach((btn) => btn.classList.remove('is-active'));
        contents.forEach((content) => content.classList.remove('is-active'));

        button.classList.add('is-active');
        if (contents[index]) {
          contents[index].classList.add('is-active');
          updateHeight(index);
        }
      });
    });

    const activeIndex = Array.from(buttons).findIndex((btn) =>
      btn.classList.contains('is-active')
    );
    if (activeIndex !== -1) {
      updateHeight(activeIndex);
    } else if (contents[0]) {
      contents[0].classList.add('is-active');
      if (buttons[0]) buttons[0].classList.add('is-active');
      updateHeight(0);
    }

    window.addEventListener('resize', () => {
      const currentActiveIndex = Array.from(buttons).findIndex((btn) =>
        btn.classList.contains('is-active')
      );
      if (currentActiveIndex !== -1) {
        updateHeight(currentActiveIndex);
      }
    });
  });
});
